module.exports = __webpack_public_path__ + "assets/b59d94c3f70265e023f70600322feaac.png";